import Image from "next/image";
import Link from "next/link";

const FOOTER_LINKS = [
	{
		heading: "About PropTechBuzz",
		links: [
			{
				href: "/about-us",
				label: "About us",
			},
			{
				href: "https://blog.proptechbuzz.com/",
				label: "Blog",
			},
			{
				href: "/job-board",
				label: "Job Board",
			},
			{
				href: "#",
				label: "Buyer Experience",
			},
		],
	},
	{
		heading: "Grow with us",
		links: [
			{
				href: "https://docs.google.com/forms/d/e/1FAIpQLScftZ7aCg7EhnYXdlsIIG4c6WLSSZcIQfJAI2TPjrR73IpKJQ/viewform?usp=send_form",
				label: "Launch on PropTechBuzz",
			},
			{
				href: "/contact-us",
				label: "Contact Us",
			},
		],
	},
];

export const Footer = () => {
	return (
		<footer className="mt-10 bg-[#1A2033] text-gray-50">
			<div className="mx-auto flex max-w-7xl flex-col gap-10 px-4 py-8 md:flex-row md:py-16">
				<Link href="/" className="inline-block">
					<div className="mb-2">
					<Image
						src="/images/proptechbuzz-logo.svg"
						alt="PropTechBuzz Logo"
						width={52}
						height={52}
						className="w-48 fill-white lg:w-52"
					/>
						
					</div>
					<p className="text-sm md:max-w-[300px] lg:max-w-max">
						Amplifying your product launch on the global stage
					</p>
				</Link>

				<div className="flex flex-col gap-8 md:ml-auto md:flex-row md:gap-20 lg:gap-28">
					{FOOTER_LINKS.map((linkGroup) => (
						<div key={linkGroup.heading} className="w-max">
							<h3 className="mb-2 font-semibold">{linkGroup.heading}</h3>
							<div className="flex flex-col gap-2.5 font-normal text-gray-300">
								{linkGroup.links.map((link) => (
									<Link key={link.href} href={link.href} className="text-sm">
										{link.label}
									</Link>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</footer>
	);
};
